module.exports = __webpack_public_path__ + "static/img/p1_3.663f987.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/product/p1_3.png
// module id = Tm4O
// module chunks = 1